var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntelliJ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.17736 25.0508L0.646484 19.0919L4.37537 12.1094L15.1599 16.3135L8.17736 25.0508Z",
    fill: "url(#paint0_linear_1320_7620)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5008 9.03862L30.9159 27.0981L18.925 31.9237L11.7231 27.2444L22.2518 16.3136L17.6455 6.15056L21.8131 1.17871L31.5008 9.03862Z",
    fill: "url(#paint1_linear_1320_7620)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5004 9.03862L21.9954 20.2618L17.645 6.15056L21.8126 1.17871L31.5004 9.03862Z",
    fill: "url(#paint2_linear_1320_7620)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3055 26.5861L2.83931 31.1558L4.81343 24.1367L7.40902 15.4359L0.280273 13.0597L4.81343 0.703125L14.5743 1.87298L24.2256 12.9134L15.3055 26.5861Z",
    fill: "url(#paint3_linear_1320_7620)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6522 6.55176H6.13037V26.0735H25.6522V6.55176Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99463 22.4192H15.3062V23.6256H7.99463V22.4192ZM13.2224 10.5745V9.11218H9.23759V10.5745H10.3709V15.6926H9.23759V17.1914H13.2224V15.6926H12.0891V10.5745H13.2224ZM17.134 17.3011C16.5795 17.3193 16.0284 17.2066 15.5255 16.9721C15.1174 16.7529 14.757 16.4546 14.4653 16.0947L15.5986 14.8517C15.8131 15.0661 16.0455 15.2618 16.2932 15.4367C16.5195 15.5864 16.7915 15.6512 17.0609 15.6195C17.2061 15.6318 17.352 15.6082 17.4859 15.5508C17.6197 15.4934 17.7374 15.404 17.8286 15.2904C18.0513 14.9981 18.1557 14.6327 18.1211 14.2668V9.03906H19.9124V14.3034C19.9443 14.7381 19.882 15.1745 19.7296 15.5829C19.5907 15.9889 19.3518 16.3535 19.035 16.6431C18.466 17.0172 17.8126 17.2434 17.134 17.3011Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1320_7620",
    x1: 0.585799,
    y1: 18.5436,
    x2: 14.9661,
    y2: 18.5436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F97A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B07B58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#577BAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E7CE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1320_7620",
    x1: 12.1202,
    y1: 12.3763,
    x2: 37.4866,
    y2: 18.0979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#CB7A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#9E7B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#757B91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#537BB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#387CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#237CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#147CEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0B7CF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1320_7620",
    x1: 28.2804,
    y1: 19.5724,
    x2: 17.3737,
    y2: 2.24304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE315D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CB417E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#9E4E9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#755BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5365CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#386DDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2374E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#1478F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0B7BF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1320_7620",
    x1: 4.69132,
    y1: 7.72442,
    x2: 31.0502,
    y2: 34.3909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE315D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F63462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#DF3A71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#C24383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#AD4A91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#755BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#1D76ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelliJ);
export default __webpack_public_path__ + "static/media/intelliJ.a447e9c4e1b6b5cd0eabc01d9e4a5491.svg";
export { ForwardRef as ReactComponent };